
<div class="neq-page-wrapper">
  <div style="width: 100%;">
    <div class="neq-container" style="width: 100%;">
      <div fxFlex="50" style="padding-right: 25px;">
        <div [formGroup]="optionalForm">
          <div class="title-group">
            <span> {{ 'label.common.sample' | translate }} </span>
          </div>
  
          <div class="input-group">
            <div class="input-label">
              <span> {{ 'label.common.order-number' | translate }}</span>
            </div>
            <div class="input">
              <mat-form-field class="no-forced-style">
                <input formControlName="orderNumber" matInput/>
              </mat-form-field>
            </div>
          </div>
  
          <div class="input-group">
            <div class="input-label">
              <span> {{ 'label.common.contract-code' | translate }}</span>
            </div>
            <div class="input">
              <mat-form-field class="no-forced-style">
                <input formControlName="contractCode" matInput/>
              </mat-form-field>
            </div>
          </div>
  
          <div class="input-group">
            <div class="input-label">
              <span> {{ 'label.common.lab-file-number' | translate }}</span>
            </div>
            <div class="input">
              <mat-form-field class="no-forced-style">
                <input formControlName="supplierFileNumber" matInput/>
              </mat-form-field>
            </div>
          </div>
  
          <div class="input-group">
            <div class="input-label">
              <span> {{ 'label.common.sample-version' | translate }}</span>
            </div>
            <div class="input">
              <mat-form-field class="no-forced-style">
                <input formControlName="supplierSampleVersion" matInput/>
              </mat-form-field>
            </div>
          </div>
  
          <div class="input-group">
            <div class="input-label">
              <span> {{ 'label.common.raw-weight' | translate }}</span>
            </div>
            <div class="input">
              <mat-form-field class="no-forced-style">
                <input formControlName="rawWeight" matInput/>
                <mat-error *ngIf="optionalForm.controls.rawWeight.errors?.pattern">
                  {{'error.common.decimal.invalid' | translate}}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
  
          <div class="input-group">
            <div class="input-label">
              <span> {{ 'label.common.variety' | translate }}</span>
            </div>
            <div class="input">
              <mat-form-field class="no-forced-style">
                <input formControlName="variety" matInput/>
              </mat-form-field>
            </div>
          </div>
    
          <div class="input-group">
            <div class="input-label">
              <span> {{ 'label.common.plot' | translate }}</span>
            </div>
            <div class="input">
              <mat-form-field class="no-forced-style">
                <input formControlName="plot" matInput/>
              </mat-form-field>
            </div>
          </div>
    
          <div class="input-group">
            <div class="input-label">
              <span> {{ 'label.common.silo' | translate }}</span>
            </div>
            <div class="input">
              <mat-form-field class="no-forced-style">
                <input formControlName="silo" matInput/>
              </mat-form-field>
            </div>
          </div>
    
          <div class="input-group">
            <div class="input-label">
              <span> {{ 'label.common.label' | translate }}</span>
            </div>
            <div class="input">
              <mat-form-field class="no-forced-style">
                <input formControlName="tag" matInput/>
              </mat-form-field>
            </div>
          </div>
    
          <div class="input-group">
            <div class="input-label">
              <span> {{ 'label.common.chop-code' | translate }}</span>
            </div>
            <div class="input">
              <mat-form-field class="no-forced-style">
                <input formControlName="chopCode" matInput/>
              </mat-form-field>
            </div>
          </div>
    
          <div class="input-group">
            <div class="input-label">
              <span> {{ 'label.common.chop' | translate }}</span>
            </div>
            <div class="input">
              <mat-form-field class="no-forced-style">
                <input formControlName="chop" matInput/>
              </mat-form-field>
            </div>
          </div>
    
          <div class="input-group">
            <div class="input-label">
              <span> {{ 'label.common.sampling-date' | translate }}</span>
            </div>
            <div class="input">
              <div class="date-input">
                <p-calendar
                  dateFormat="{{returnDateFormat()}}"
                  formControlName="samplingDate"
                ></p-calendar>
              </div>
            </div>
          </div>
    
          <div class="input-group">
            <div class="input-label">
              <span> {{ 'label.common.reception-date' | translate }}</span>
            </div>
            <div class="input">
              <div class="date-input">
                <p-calendar
                  dateFormat="{{returnDateFormat()}}"
                  formControlName="receptionDate"
              ></p-calendar>
              </div>
            </div>
          </div>
    
          <div class="input-group">
            <div class="input-label">
              <span> {{ 'label.common.harvest-date' | translate }}</span>
            </div>
            <div class="input">
              <div class="date-input">
                <p-calendar
                  dateFormat="{{returnDateFormat()}}"
                  formControlName="harvestDate"
                ></p-calendar>
              </div>
            </div>
          </div>
        </div>
  
        <div [formGroup]="optionalForm.get('farm')">
          <div class="title-group">
            <span> {{ 'label.common.farm' | translate }} </span>
          </div>
  
          <div class="input-group">
            <div class="input-label">
              <span> {{ 'label.common.farm-postal-code' | translate }}</span>
            </div>
            <div class="input">
              <mat-form-field class="no-forced-style">
                <input formControlName="postcode" matInput/>
              </mat-form-field>
            </div>
          </div>
          
          <div class="input-group">
            <div class="input-label">
              <span> {{ 'label.common.farm-region' | translate }}</span>
            </div>
            <div class="input">
              <mat-form-field class="no-forced-style">
                <input formControlName="region" matInput/>
              </mat-form-field>
            </div>
          </div>
          
          <div class="input-group">
            <div class="input-label">
              <span> {{ 'label.common.farm-code' | translate }}</span>
            </div>
            <div class="input">
              <mat-form-field class="no-forced-style">
                <input formControlName="code" matInput/>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    
      <div fxFlex="50">
        <div [formGroup]="getSupplierForm()">
          <div class="title-group">
            <span> {{ 'label.common.laboratory' | translate }} </span>
            <div class="button-group-div">
              <button pButton class="selection-button"
                [class.selected]="!isFormSelected('supplier')" (click)="unselectForm('supplier')"
              >
                {{ 'label.common.sample' | translate }}</button>
              <button pButton class="selection-button"
                [class.selected]="isFormSelected('supplier')" (click)="selectForm('supplier')"
              >
                {{ 'label.common.laboratory' | translate }}
              </button>
            </div>
          </div>
          
          <div class="input-group">
            <div class="input-label">
              <span> {{ 'label.common.lab-address1' | translate }}</span>
            </div>
            <div class="input">
              <mat-form-field class="no-forced-style">
                <input formControlName="address" matInput/>
              </mat-form-field>
            </div>
          </div>
          
          <div class="input-group">
            <div class="input-label">
              <span> {{ 'label.common.lab-address2' | translate }}</span>
            </div>
            <div class="input">
              <mat-form-field class="no-forced-style">
                <input formControlName="address1" matInput/>
              </mat-form-field>
            </div>
          </div>
          
          <div class="input-group">
            <div class="input-label">
              <span> {{ 'label.common.lab-city' | translate }}</span>
            </div>
            <div class="input">
              <mat-form-field class="no-forced-style">
                <input formControlName="city" matInput/>
              </mat-form-field>
            </div>
          </div>
          
          <div class="input-group">
            <div class="input-label">
              <span> {{ 'label.common.lab-country' | translate }}</span>
            </div>
            <div class="input">
              <mat-form-field class="no-forced-style">
                <input formControlName="country" matInput/>
              </mat-form-field>
            </div>
          </div>
          
          <div class="input-group">
            <div class="input-label">
              <span> {{ 'label.common.lab-email' | translate }}</span>
            </div>
            <div class="input">
              <mat-form-field class="no-forced-style">
                <input formControlName="email" matInput/>
                <mat-error *ngIf="getSupplierForm().controls.email.errors?.email">
                  {{ 'error.common.email.invalid' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          
          <div class="input-group">
            <div class="input-label">
              <span> {{ 'label.common.lab-phone' | translate }}</span>
            </div>
            <div class="input">
              <mat-form-field class="no-forced-style">
                <input formControlName="telephone" matInput/>
              </mat-form-field>
            </div>
          </div>
        </div>
  
        <div [formGroup]="getCustomerForm()">
          <div class="title-group">
            <span> {{ 'label.common.customer' | translate }} </span>
            <div class="button-group-div">
              <button pButton class="selection-button"
                [class.selected]="!isFormSelected('customer')" (click)="unselectForm('customer')"
              >
                {{ 'label.common.sample' | translate }}</button>
              <button pButton class="selection-button"
                [class.selected]="isFormSelected('customer')" (click)="selectForm('customer')"
              >
                {{ 'label.common.entity' | translate }}
              </button>
            </div>
          </div>
          
          <div class="input-group">
            <div class="input-label">
              <span> {{ 'label.common.customer-send-number' | translate }}</span>
            </div>
            <div class="input">
              <mat-form-field class="no-forced-style">
                <input formControlName="sendNumber" matInput/>
              </mat-form-field>
            </div>
          </div>
          
          <div class="input-group">
            <div class="input-label">
              <span> {{ 'label.common.customer-batch-code' | translate }}</span>
            </div>
            <div class="input">
              <mat-form-field class="no-forced-style">
                <input formControlName="batchCode" matInput/>
              </mat-form-field>
            </div>
          </div>
          
          <div class="input-group">
            <div class="input-label">
              <span> {{ 'label.common.customer-address1' | translate }}</span>
            </div>
            <div class="input">
              <mat-form-field class="no-forced-style">
                <input formControlName="address" matInput/>
              </mat-form-field>
            </div>
          </div>
          
          <div class="input-group">
            <div class="input-label">
              <span> {{ 'label.common.customer-address2' | translate }}</span>
            </div>
            <div class="input">
              <mat-form-field class="no-forced-style">
                <input formControlName="address1" matInput/>
              </mat-form-field>
            </div>
          </div>
          
          <div class="input-group">
            <div class="input-label">
              <span> {{ 'label.common.customer-postal-code' | translate }}</span>
            </div>
            <div class="input">
              <mat-form-field class="no-forced-style">
                <input formControlName="postcode" matInput/>
              </mat-form-field>
            </div>
          </div>
          
          <div class="input-group">
            <div class="input-label">
              <span> {{ 'label.common.customer-city' | translate }}</span>
            </div>
            <div class="input">
              <mat-form-field class="no-forced-style">
                <input formControlName="city" matInput/>
              </mat-form-field>
            </div>
          </div>
          
          <div class="input-group">
            <div class="input-label">
              <span> {{ 'label.common.customer-country' | translate }}</span>
            </div>
            <div class="input">
              <mat-form-field class="no-forced-style">
                <input formControlName="country" matInput/>
              </mat-form-field>
            </div>
          </div>
          
          <div class="input-group">
            <div class="input-label">
              <span> {{ 'label.common.distributor' | translate }}</span>
            </div>
            <div class="input">
              <mat-form-field class="no-forced-style">
                <input formControlName="distributor" matInput/>
              </mat-form-field>
            </div>
          </div>
          
          <div class="input-group">
            <div class="input-label">
              <span> {{ 'label.common.customer-commercial-region' | translate }}</span>
            </div>
            <div class="input">
              <mat-form-field class="no-forced-style">
                <input formControlName="commercialRegion" matInput/>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>  
    </div>
    
    <div class="neq-container" style="width: 100%;">
      <div fxFlex="100">
        <div [formGroup]="optionalForm">
          <div class="title-group">
            <span> {{ 'label.common.comment' | translate }} </span>
          </div>
        
          <div class="input-group">
            <div class="input-label large-div">
              <span> {{ 'label.common.technician-observation' | translate }}</span>
            </div>
            <div class="input large-div">
              <textarea select-all matInput formControlName="technicianObservation"></textarea>
            </div>
          </div>
          
          <div class="input-group">
            <div class="input-label large-div">
              <span> {{ 'label.common.lab-comment' | translate }}</span>
            </div>
            <div class="input large-div">
              <textarea select-all matInput formControlName="supplierComment"></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <aside fxFlex="290px">
    <div class="neq-action-button" fxLayoutAlign="end center">
      <button pButton
        [disabled]="!canSave"
        class="neq-primeng-button primeng-flat"
        [matTooltip]="'msg.common.icon.save' | translate"
        (click)="save()"
      >
        <neq-icon svgIcon="enregistrer"></neq-icon>
      </button>
    </div>
    <neq-event-list [auditableDto]="sample"></neq-event-list>

    <div class="neq-container neq-aside-container">
      <h3>
        <neq-icon svgIcon="notes"></neq-icon>&nbsp;{{ 'label.common.notes' | translate }}
      </h3>
      <textarea select-all matInput [formControl]="notesForm"></textarea>
    </div>
  </aside>
</div>
